export type ProvisionedTeam = {
    team_id: string
    team_name: string
}

export function jsonSafeToProvisionedTeams(json: Record<string, any>): ProvisionedTeam[] {
    return json[0].map((item: string, idx: number) => {
        return {
            team_id: item,
            team_name: json[1][idx]
        }
    })
}